"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const CustomTypeModelSliceDisplay = {
  List: "list",
  Grid: "grid"
};
exports.CustomTypeModelSliceDisplay = CustomTypeModelSliceDisplay;
//# sourceMappingURL=slice.cjs.map
